const defaultChartState = {
  "layout": "s",
  "charts": [
    {
      "panes": [

      ],
      "timeScale": {
        "m_barSpacing": 10,
        "m_rightOffset": 0
      },
      "chartProperties": {
        "paneProperties": {
          "background": "#ffffff",
          "gridProperties": {
            "color": "#e1ecf2",
            "style": 0
          },
          "vertGridProperties": {
            "color": "#e1ecf2",
            "style": 0
          },
          "horzGridProperties": {
            "color": "#e1ecf2",
            "style": 0
          },
          "crossHairProperties": {
            "color": "rgba( 152, 152, 152, 1)",
            "style": 2,
            "transparency": 0,
            "width": 1
          },
          "topMargin": 5,
          "bottomMargin": 5,
          "leftAxisProperties": {
            "autoScale": true,
            "autoScaleDisabled": false,
            "percentage": false,
            "percentageDisabled": false,
            "log": false,
            "logDisabled": false,
            "alignLabels": true
          },
          "rightAxisProperties": {
            "autoScale": true,
            "autoScaleDisabled": false,
            "percentage": false,
            "percentageDisabled": false,
            "log": false,
            "logDisabled": false,
            "alignLabels": true
          },
          "overlayPropreties": {
            "autoScale": true,
            "autoScaleDisabled": false,
            "percentage": false,
            "percentageDisabled": false,
            "log": false,
            "logDisabled": false,
            "alignLabels": true
          },
          "legendProperties": {
            "showStudyArguments": false,
            "showStudyTitles": false,
            "showStudyValues": false,
            "showSeriesTitle": false,
            "showSeriesOHLC": false,
            "showLegend": false
          }
        },
        "scalesProperties": {
          "showLeftScale": false,
          "showRightScale": true,
          "backgroundColor": "#ffffff",
          "lineColor": "#555",
          "textColor": "#555",
          "fontSize": 11,
          "scaleSeriesOnly": false,
          "showSeriesLastValue": true,
          "showSeriesPrevCloseValue": false,
          "showStudyLastValue": false,
          "showSymbolLabels": false,
          "showStudyPlotLabels": false
        },
        "chartEventsSourceProperties": {
          "visible": true,
          "futureOnly": true,
          "breaks": {
            "color": "rgba(85, 85, 85, 1)",
            "visible": false,
            "style": 2,
            "width": 1
          }
        }
      },
      "version": 2,
      "timezone": Intl.DateTimeFormat().resolvedOptions().timeZone
    }
  ]
};

const getNewSource = (id, symbol) => {
  return  {
    "type": "study_Overlay",
    "id": id,
    "state": {
      "styles": {
        "open": {
          "visible": true,
          "color": "#ff4d00",
          "linestyle": 0,
          "linewidth": 1,
          "plottype": 0,
          "histogramBase": 0,
          "transparency": 50,
          "trackPrice": false,
          "joinPoints": false,
          "title": "open"
        },
        "high": {
          "visible": true,
          "color": "#ff4d00",
          "linestyle": 0,
          "linewidth": 1,
          "plottype": 0,
          "histogramBase": 0,
          "transparency": 50,
          "trackPrice": false,
          "joinPoints": false,
          "title": "high"
        },
        "low": {
          "visible": true,
          "color": "#ff4d00",
          "linestyle": 0,
          "linewidth": 1,
          "plottype": 0,
          "histogramBase": 0,
          "transparency": 50,
          "trackPrice": false,
          "joinPoints": false,
          "title": "low"
        },
        "close": {
          "visible": true,
          "color": "#ff4d00",
          "linestyle": 0,
          "linewidth": 1,
          "plottype": 0,
          "histogramBase": 0,
          "transparency": 50,
          "trackPrice": false,
          "joinPoints": false,
          "title": "close"
        }
      },
      "precision": "default",
      "inputs": {
        "symbol": symbol
      },
      "style": 2,
      "showPriceLine": false,
      "minTick": "default",
      "candleStyle": {
        "upColor": "rgba( 107, 165, 131, 1)",
        "downColor": "rgba( 215, 84, 66, 1)",
        "drawWick": true,
        "drawBorder": true,
        "borderColor": "rgba( 55, 134, 88, 1)",
        "borderUpColor": "rgba( 34, 84, 55, 1)",
        "borderDownColor": "rgba( 91, 26, 19, 1)",
        "wickColor": "rgba( 115, 115, 117, 1)",
        "wickUpColor": "rgba( 115, 115, 117, 1)",
        "wickDownColor": "rgba( 115, 115, 117, 1)",
        "barColorsOnPrevClose": false
      },
      "hollowCandleStyle": {
        "upColor": "rgba( 107, 165, 131, 1)",
        "downColor": "rgba( 215, 84, 66, 1)",
        "drawWick": true,
        "drawBorder": true,
        "borderColor": "rgba( 55, 134, 88, 1)",
        "borderUpColor": "rgba( 34, 84, 55, 1)",
        "borderDownColor": "rgba( 91, 26, 19, 1)",
        "wickColor": "rgba( 115, 115, 117, 1)",
        "wickUpColor": "rgba( 115, 115, 117, 1)",
        "wickDownColor": "rgba( 115, 115, 117, 1)",
        "barColorsOnPrevClose": false
      },
      "barStyle": {
        "upColor": "rgba( 107, 165, 131, 1)",
        "downColor": "rgba( 215, 84, 66, 1)",
        "barColorsOnPrevClose": false,
        "dontDrawOpen": false
      },
      "lineStyle": {
        "color": "rgba( 3, 3, 247, 1)",
        "linestyle": 0,
        "linewidth": 1,
        "priceSource": "close",
        "styleType": 2
      },
      "areaStyle": {
        "color1": "rgba( 96, 96, 144, 0.5)",
        "color2": "rgba( 1, 246, 245, 0.5)",
        "linecolor": "rgba( 0, 148, 255, 1)",
        "linestyle": 0,
        "linewidth": 1,
        "priceSource": "close",
        "transparency": 50
      },
      "baselineStyle": {
        "baselineColor": "rgba( 117, 134, 150, 1)",
        "topFillColor1": "rgba( 83, 185, 135, 0.1)",
        "topFillColor2": "rgba( 83, 185, 135, 0.1)",
        "bottomFillColor1": "rgba( 235, 77, 92, 0.1)",
        "bottomFillColor2": "rgba( 235, 77, 92, 0.1)",
        "topLineColor": "rgba( 83, 185, 135, 1)",
        "bottomLineColor": "rgba( 235, 77, 92, 1)",
        "topLineWidth": 1,
        "bottomLineWidth": 1,
        "priceSource": "close",
        "transparency": 50,
        "baseLevelPercentage": 50
      },
      "palettes": {},
      "bands": {},
      "area": {},
      "graphics": {},
      "showInDataWindow": true,
      "visible": true,
      "showStudyArguments": true,
      "plots": {
        "0": {
          "id": "open",
          "type": "line"
        },
        "1": {
          "id": "high",
          "type": "line"
        },
        "2": {
          "id": "low",
          "type": "line"
        },
        "3": {
          "id": "close",
          "type": "line"
        }
      },
      "_metainfoVersion": 15,
      "isTVScript": false,
      "isTVScriptStub": false,
      "is_hidden_study": true,
      "description": "Overlay",
      "shortDescription": "Overlay",
      "is_price_study": false,
      "id": "Overlay@tv-basicstudies",
      "description_localized": "Overlay",
      "shortId": "Overlay",
      "packageId": "tv-basicstudies",
      "version": "1",
      "fullId": "Overlay@tv-basicstudies-1",
      "productId": "tv-basicstudies",
      "name": "Overlay@tv-basicstudies"
    },
    "zorder": -4,
    "metaInfo": {
      "palettes": {},
      "inputs": [
        {
          "id": "symbol",
          "name": "symbol",
          "defval": "",
          "type": "symbol",
          "isHidden": true
        }
      ],
      "plots": [
        {
          "id": "open",
          "type": "line"
        },
        {
          "id": "high",
          "type": "line"
        },
        {
          "id": "low",
          "type": "line"
        },
        {
          "id": "close",
          "type": "line"
        }
      ],
      "graphics": {},
      "defaults": {
        "styles": {},
        "precision": 4,
        "inputs": {
          "symbol": ""
        }
      },
      "_metainfoVersion": 15,
      "isTVScript": false,
      "isTVScriptStub": false,
      "is_hidden_study": true,
      "styles": {
        "open": {
          "title": "open"
        },
        "high": {
          "title": "high"
        },
        "low": {
          "title": "low"
        },
        "close": {
          "title": "close"
        }
      },
      "description": "Overlay",
      "shortDescription": "Overlay",
      "is_price_study": false,
      "id": "Overlay@tv-basicstudies-1",
      "description_localized": "Overlay",
      "shortId": "Overlay",
      "packageId": "tv-basicstudies",
      "version": "1",
      "fullId": "Overlay@tv-basicstudies-1",
      "productId": "tv-basicstudies",
      "name": "Overlay@tv-basicstudies"
    }
  }
};

const getDefaultChartState = () => JSON.parse(JSON.stringify(defaultChartState));

const getNewPane = () => {
  return   {
    "sources": [],
    "leftAxisState": {
      "m_priceRange": null,
      "m_isAutoScale": true,
      "m_isPercentage": false,
      "m_isLog": false,
      "m_height": 700,
      "m_topMargin": 0.05,
      "m_bottomMargin": 0.05
    },
    "leftAxisSources": [],
    "rightAxisState": {
      "m_priceRange": null,
      "m_isAutoScale": true,
      "m_isPercentage": false,
      "m_isLog": false,
      "m_height": 700,
      "m_topMargin": 0.05,
      "m_bottomMargin": 0.05
    },
    "rightAxisSources": [
      "mainSeries"
    ],
    "stretchFactor": 20000,
    "mainSourceId": "mainSeries"
  }
};

const getMainPane = (id) => {
  return     {
    "sources": [
      {
        "type": "MainSeries",
        "id": id,
        "state": {
          "style": 2,
          "esdShowDividends": true,
          "esdShowSplits": true,
          "esdShowEarnings": true,
          "esdShowBreaks": false,
          "esdBreaksStyle": {
            "color": "rgba( 226, 116, 91, 1)",
            "style": 2,
            "width": 1
          },
          "esdFlagSize": 2,
          "showCountdown": false,
          "showInDataWindow": true,
          "visible": true,
          "silentIntervalChange": false,
          "showPriceLine": true,
          "priceLineWidth": 1,
          "priceLineColor": "",
          "showPrevClosePriceLine": false,
          "prevClosePriceLineWidth": 1,
          "prevClosePriceLineColor": "rgba( 85, 85, 85, 1)",
          "lockScale": false,
          "minTick": "default",
          "extendedHours": false,
          "sessVis": false,
          "statusViewStyle": {
            "fontSize": 17,
            "showExchange": true,
            "showInterval": true,
            "showSymbolAsDescription": false
          },
          "candleStyle": {
            "upColor": "#53b987",
            "downColor": "#eb4d5c",
            "drawWick": true,
            "drawBorder": true,
            "borderColor": "#378658",
            "borderUpColor": "#53b987",
            "borderDownColor": "#eb4d5c",
            "wickColor": "#737375",
            "wickUpColor": "#a9cdd3",
            "wickDownColor": "#f5a6ae",
            "barColorsOnPrevClose": false
          },
          "hollowCandleStyle": {
            "upColor": "rgba( 83, 185, 135, 1)",
            "downColor": "rgba( 255, 77, 92, 1)",
            "drawWick": true,
            "drawBorder": true,
            "borderColor": "rgba( 55, 134, 88, 1)",
            "borderUpColor": "rgba( 83, 185, 135, 1)",
            "borderDownColor": "rgba( 255, 77, 92, 1)",
            "wickColor": "rgba( 115, 115, 117, 1)",
            "wickUpColor": "rgba( 169, 220, 195, 1)",
            "wickDownColor": "rgba( 245, 166, 174, 1)"
          },
          "haStyle": {
            "upColor": "rgba( 83, 185, 135, 1)",
            "downColor": "rgba( 255, 77, 92, 1)",
            "drawWick": true,
            "drawBorder": true,
            "borderColor": "rgba( 55, 134, 88, 1)",
            "borderUpColor": "rgba( 83, 185, 135, 1)",
            "borderDownColor": "rgba( 255, 77, 92, 1)",
            "wickColor": "rgba( 115, 115, 117, 1)",
            "wickUpColor": "rgba( 83, 185, 135, 1)",
            "wickDownColor": "rgba( 255, 77, 92, 1)",
            "showRealLastPrice": false,
            "barColorsOnPrevClose": false,
            "inputs": {},
            "inputInfo": {}
          },
          "barStyle": {
            "upColor": "rgba( 83, 185, 135, 1)",
            "downColor": "rgba( 255, 77, 92, 1)",
            "barColorsOnPrevClose": false,
            "dontDrawOpen": false
          },
          "lineStyle": {
            "color": "rgba( 60, 120, 216, 1)",
            "linestyle": 0,
            "linewidth": 1,
            "priceSource": "close",
            "styleType": 2
          },
          "areaStyle": {
            "color1": "rgba( 96, 96, 144, 0.5)",
            "color2": "rgba( 1, 246, 245, 0.5)",
            "linecolor": "rgba( 0, 148, 255, 1)",
            "linestyle": 0,
            "linewidth": 1,
            "priceSource": "close",
            "transparency": 50
          },
          "priceAxisProperties": {
            "autoScale": true,
            "autoScaleDisabled": false,
            "percentage": false,
            "percentageDisabled": false,
            "log": false,
            "logDisabled": false,
            "alignLabels": true
          },
          "renkoStyle": {
            "upColor": "rgba( 83, 185, 135, 1)",
            "downColor": "rgba( 255, 77, 92, 1)",
            "borderUpColor": "rgba( 83, 185, 135, 1)",
            "borderDownColor": "rgba( 255, 77, 92, 1)",
            "upColorProjection": "rgba( 169, 220, 195, 1)",
            "downColorProjection": "rgba( 245, 166, 174, 1)",
            "borderUpColorProjection": "rgba( 169, 220, 195, 1)",
            "borderDownColorProjection": "rgba( 245, 166, 174, 1)",
            "wickUpColor": "rgba( 83, 185, 135, 1)",
            "wickDownColor": "rgba( 255, 77, 92, 1)",
            "inputs": {
              "source": "close",
              "boxSize": 3,
              "style": "ATR",
              "atrLength": 14,
              "wicks": true
            },
            "inputInfo": {
              "source": {
                "name": "Source"
              },
              "boxSize": {
                "name": "Box size"
              },
              "style": {
                "name": "Style"
              },
              "atrLength": {
                "name": "ATR Length"
              },
              "wicks": {
                "name": "Wicks"
              }
            }
          },
          "pbStyle": {
            "upColor": "rgba( 83, 185, 135, 1)",
            "downColor": "rgba( 255, 77, 92, 1)",
            "borderUpColor": "rgba( 83, 185, 135, 1)",
            "borderDownColor": "rgba( 255, 77, 92, 1)",
            "upColorProjection": "rgba( 169, 220, 195, 1)",
            "downColorProjection": "rgba( 245, 166, 174, 1)",
            "borderUpColorProjection": "rgba( 169, 220, 195, 1)",
            "borderDownColorProjection": "rgba( 245, 166, 174, 1)",
            "inputs": {
              "source": "close",
              "lb": 3
            },
            "inputInfo": {
              "source": {
                "name": "Source"
              },
              "lb": {
                "name": "Number of line"
              }
            }
          },
          "kagiStyle": {
            "upColor": "rgba( 83, 185, 135, 1)",
            "downColor": "rgba( 255, 77, 92, 1)",
            "upColorProjection": "rgba( 169, 220, 195, 1)",
            "downColorProjection": "rgba( 245, 166, 174, 1)",
            "inputs": {
              "source": "close",
              "style": "ATR",
              "atrLength": 14,
              "reversalAmount": 1
            },
            "inputInfo": {
              "source": {
                "name": "Source"
              },
              "style": {
                "name": "Style"
              },
              "atrLength": {
                "name": "ATR Length"
              },
              "reversalAmount": {
                "name": "Reversal amount"
              }
            }
          },
          "pnfStyle": {
            "upColor": "rgba( 83, 185, 135, 1)",
            "downColor": "rgba( 255, 77, 92, 1)",
            "upColorProjection": "rgba( 169, 220, 195, 1)",
            "downColorProjection": "rgba( 245, 166, 174, 1)",
            "inputs": {
              "sources": "Close",
              "reversalAmount": 3,
              "boxSize": 1,
              "style": "ATR",
              "atrLength": 14
            },
            "inputInfo": {
              "sources": {
                "name": "Source"
              },
              "boxSize": {
                "name": "Box size"
              },
              "reversalAmount": {
                "name": "Reversal amount"
              },
              "style": {
                "name": "Style"
              },
              "atrLength": {
                "name": "ATR Length"
              }
            }
          },
          "baselineStyle": {
            "baselineColor": "rgba( 117, 134, 150, 1)",
            "topFillColor1": "rgba( 83, 185, 135, 0.1)",
            "topFillColor2": "rgba( 83, 185, 135, 0.1)",
            "bottomFillColor1": "rgba( 235, 77, 92, 0.1)",
            "bottomFillColor2": "rgba( 235, 77, 92, 0.1)",
            "topLineColor": "rgba( 83, 185, 135, 1)",
            "bottomLineColor": "rgba( 235, 77, 92, 1)",
            "topLineWidth": 1,
            "bottomLineWidth": 1,
            "priceSource": "close",
            "transparency": 50,
            "baseLevelPercentage": 50
          },
          "symbol": "test",
          "shortName": "test",
          "timeframe": "",
          "onWidget": false,
          "interval": "1",
          "showSessions": false
        },
        "zorder": -1,
        "haStyle": {
          "studyId": "BarSetHeikenAshi@tv-basicstudies-60"
        },
        "renkoStyle": {
          "studyId": "BarSetRenko@tv-prostudies-15"
        },
        "pbStyle": {
          "studyId": "BarSetPriceBreak@tv-prostudies-15"
        },
        "kagiStyle": {
          "studyId": "BarSetKagi@tv-prostudies-15"
        },
        "pnfStyle": {
          "studyId": "BarSetPnF@tv-prostudies-15"
        }
      }
    ],
    "leftAxisState": {
      "m_priceRange": null,
      "m_isAutoScale": true,
      "m_isPercentage": false,
      "m_isLog": false,
      "m_topMargin": 0.05,
      "m_bottomMargin": 0.05
    },
    "leftAxisSources": [],
    "rightAxisState": {
      "m_priceRange": null,
      "m_isAutoScale": true,
      "m_isPercentage": false,
      "m_isLog": false,
      "m_topMargin": 0.05,
      "m_bottomMargin": 0.05
    },
    "rightAxisSources": [
      id
    ],
    "stretchFactor": 20000,
    "mainSourceId": id
  }
};

export {getDefaultChartState, getNewSource, getNewPane, getMainPane};


// WEBPACK FOOTER //
// ./src/components/dashboard/widgets/trading-view/chartState.js